<div class="col-lg-12 form-group" style="overflow-y: scroll; max-height: 600px;">
    <form [formGroup]="opportunityGroup">
        <div class="row">
            <div class="col-lg-12">
                <h3>{{opportunityId < 1 ? 'New' : 'Edit'}} Opportunity</h3>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group" *ngIf="customer == null || customer.customerID < 1">
                            <label><strong>Customer</strong></label>

                            <mat-form-field style="margin: 5px; width: 250px;">
                                <input type="text" placeholder="Customer" aria-label="Customer" matInput
                                        formControlName="customerCtrl"
                                        [matAutocomplete]="customerDropdown" (keydown.enter)="$event.preventDefault(); chooseFirstCustomer()" (keydown.Tab)="chooseFirstCustomer()" />
                                <mat-autocomplete #customerDropdown="matAutocomplete" (optionSelected)="customerChanged($event)" [displayWith]="displayCustomer">
                                    <mat-option *ngFor="let c of filteredCustomers | async" [value]="c">{{c.customerCode}} - {{c.customerName}}</mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="opportunityGroup.controls['customerCtrl'].hasError('required')">Please select a customer</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label><strong>Opportunity Owner</strong></label>
                            <!--<input type="text" class="form-control input-sm" formControlName="ownerName" />-->
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Owner" formControlName="ownerCtrl" required>
                                    <mat-option *ngFor="let employee of employees" [value]="employee.employeeId">
                                        {{employee.fullName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label><strong>Opportunity Name</strong></label>
                            <input type="text" class="form-control input-sm" formControlName="opportunityName" />
                        </div>
                        <div class="form-group">
                            <label><strong>Close Date</strong></label>
                            <mat-form-field>
                                <input matInput [matDatepicker]="picker" placeholder="Enter Date" formControlName="closeDate">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label><strong>Product</strong></label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Product" formControlName="productCtrl" required>
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let product of products" [value]="product.productId">
                                        {{product.productName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="opportunityGroup.controls['productCtrl'].hasError('required')">Please select a product</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <label><strong>Sales Cycle</strong></label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Sales Cycle" formControlName="salesCycleCtrl" required disabled>
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let salesCycle of salesCycles" [value]="salesCycle.salesCycleId">
                                        {{salesCycle.description}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="opportunityGroup.controls['salesCycleCtrl'].hasError('required')">Please select a sales cycle</mat-error>
                            </mat-form-field>

                        </div>
                        <div class="form-group" *ngIf="!addNewContact">
                            <label><strong>Contact</strong></label>
                            <mat-form-field style="margin: 5px;">
                                <mat-select placeholder="Contact" formControlName="contactCtrl">
                                    <mat-option>--</mat-option>
                                    <mat-option *ngFor="let contact of contacts" [value]="contact.contactID">
                                        {{contact.fullName}}
                                    </mat-option>
                                </mat-select>
                                <!--<mat-error *ngIf="opportunityGroup.controls['contactCtrl'].hasError('required')">Please select a contact</mat-error>-->
                            </mat-form-field>
                            <button class="epi-button" (click)="addNewContact = !addNewContact;">Add</button>
                        </div>
                        <div class="form-group" *ngIf="addNewContact" style="min-height: 275px;">
                            <label><strong>Name</strong></label>
                            <input type="text" class="form-control input-sm" [(ngModel)]="contactName" [ngModelOptions]="{standalone: true}" />

                            <label><strong>Phone</strong></label>
                            <kendo-maskedtextbox [mask]="phoneMask" class="form-control input-sm" type="text" [(ngModel)]="contactPhone" [ngModelOptions]="{standalone: true}"></kendo-maskedtextbox>

                            <label><strong>Email</strong></label>
                            <input type="text" class="form-control input-sm" [(ngModel)]="contactEmail" [ngModelOptions]="{standalone: true}" />

                            <label><strong>Title</strong></label>
                            <input type="text" class="form-control input-sm" [(ngModel)]="contactTitle" [ngModelOptions]="{standalone: true}" />

                            <label style="color: red;"><strong>{{contactSaveMessage}}</strong></label>
                            <button class="epi-button" (click)="$event.preventDefault(); saveContact();">Save Contact</button>
                            <button class="epi-button" (click)="addNewContact = !addNewContact;">Cancel</button>
                        </div>
                        <div class="form-group">
                            <label>Est Net Revenue</label>
                            <kendo-numerictextbox [min]="0" formControlName="amountCtrl" required></kendo-numerictextbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <button class="epi-button float-right" (click)="cancel()">Close</button>
                <button class="epi-button float-right" (click)="saveOpportunity()">Save</button>
            </div>
        </div>
    </form>
</div>


<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': savingOpportunity || loadingCustomers}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="savingOpportunity || loadingCustomers"></mat-spinner>
</div>
